import './FileDropBox.scss'

import React, { useCallback, useEffect, useRef, useState } from 'react'

import Button from '../Button/Button'
import File from '../File/File'
import classNames  from 'classnames'
import { formEvent } from '../Form/Form'
import { getFileData } from '../../helpers/upload'
import t from '../../helpers/i18n'
import { useDropzone } from 'react-dropzone'

const FileDropBox = ({ name, label, files }) => {
  const [selectedFiles, setSelectedFiles] = useState(files || [])
  const element = useRef()

  const handleRemove = useCallback((file) => {
    const files = selectedFiles.filter(selectedFile => selectedFile !== file)
    setSelectedFiles(files)
  }, [selectedFiles, setSelectedFiles])

  const onDrop = useCallback((acceptedFiles) => {
    const files = acceptedFiles.reduce((list, file) => {
      const aDuplicate = list.some(selectedFile => selectedFile.name === file.name && selectedFile.size === file.size)
      if (!aDuplicate) list.push(file)
      return list
    }, [...selectedFiles])
    setSelectedFiles(files)
  }, [selectedFiles, setSelectedFiles])

  const propagateValue = useCallback(() => {
    const files = selectedFiles.map(file => {
      const result = {
        name: file.name,
        size: file.size,
        type: (file.type && file.type.length > 0) ? file.type : 'application/octet-stream',
        get: async () => getFileData(file)
      }
      if (file.id) result.id = file.id
      return result
    })
    if (name) {
      element.current.dispatchEvent(formEvent({
        action: 'PENDING',
        name,
        value: files
      }))
    }
  }, [name, selectedFiles])

  useEffect(() => {
    const _element = element.current
    return () => {
      if (name) {
        _element.dispatchEvent(
          formEvent({
            action: 'REMOVE',
            name
          })
        )
      }
    }
  }, [name])

  useEffect(propagateValue, [propagateValue])

  const {getRootProps, getInputProps} = useDropzone({ onDrop, noClick: true })
  const inputProps = getInputProps()

  return (
    <div ref={element} className="file-drop-box">
      <div className="-label label-small-medium">{label}</div>
      <input {...inputProps} />
      <div className={classNames("-container", "-dropzone")} {...getRootProps()}>
        <div className="-files">
          {(!selectedFiles || selectedFiles.length === 0) &&
            <div className="-empty label-small-medium">{t('No_files_stored')}</div>
          }
          {selectedFiles && selectedFiles.map((file, index) => <File key={index} file={file} includeRemove onRemove={handleRemove} /> )}
        </div>
        <div className="-buttons">
          <Button
            label={t('Upload files')}
            type="light"
            size="small"
            onClick={() => inputProps.ref.current.click()}
          />
        </div>
      </div>
    </div>
  )
}

export default FileDropBox